import { Select } from "antd";
import React, { useState } from "react";
import styles from "./index.module.scss";

function DashboardSpanSelect({ onChange, value }) {
  //   let spans = [{ name: "Daily" }, { name: "Weekly" }, { name: "Monthly" }];
  //   let [activeSpan, setActiveSpan] = useState(spans[0]?.name);
  //   let onClickItem=(name)=>{
  //     setActiveSpan(name)
  //   }

  return (
    // <div className={styles.spanSelectContainer}>
    //   {spans.map((each, key) => {
    //     return <div onClick={()=>{onClickItem(each?.name)}} className={`${styles.spanSelectItem} ${activeSpan===each.name&&styles.spanSelectItemActive}`}>{each?.name}</div>;
    //   })}
    // </div>

    <Select
      defaultValue={value || "Weekly"}
      onChange={onChange}
      className={styles.spanSelectDrop}
      placeholder="Select frequency"
      style={{
        width: 220,
      }}
      options={[
        {
          value: "Daily",
          label: "Today",
        },
        {
          value: "Weekly",
          label: "Last week",
        },
        {
          value: "Monthly",
          label: "Last month",
        },
      ]}
    />
  );
}

export default DashboardSpanSelect;
